// extracted by mini-css-extract-plugin
module.exports = {"mj_container":"index_mj_container__L6U37"};